<template>
  <ul class="MachineRoomCom">
    <el-empty
      style="width: 100%; margin: 0 auto"
      v-if="showMsg"
      description="该资产下设备已离线"
    ></el-empty>
    <li v-else v-for="(v, i) in panelList" :key="i">
      <ControlPanel :list="v" @getChangeValue="getChangeValue" />
    </li>
  </ul>
</template>

<script>
import api from "@/api";
import ControlPanel from "@/components/zixitong/airSystem/control/ControlPanel.vue";
export default {
  props: {
    treeAllData: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    ControlPanel,
  },
  watch: {
    treeAllData: {
      handler(newvalue, oldvalue) {
        this.handlerData();
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      panelList: [],
      showMsg: false,
    };
  },
  methods: {
    handlerData() {
      this.panelList = [];
      if (
        this.treeAllData.treeActive?.id &&
        !this.treeAllData.treeActive?.active
      ) {
        this.showMsg = true;
      } else if (this.treeAllData.treeActive?.id) {
        this.showMsg = false;
        this.getMachineRoomList();
      }
    },
    async getMachineRoomList() {
       this.$store.commit("SET_LOADING", true);
      let res = await api.ACRGetMachineRoomList({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        assetId: this.treeAllData.treeActive.id,
        active: this.treeAllData.treeActive.active,
        energyType: this.treeAllData.treeActive.energyType,
      });
      // console.log(res);
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        this.panelList = res.data.data;
        this.panelList.map((v) => {
          v.activeType = this.treeAllData.active;
        });
      }
    },
    async getChangeValue(data) {
      this.$store.commit("SET_LOADING", true);
      let res = await api.subsystemControlSwitch({
        entityId: data.id,
        modular: "开关",
        type: "风机盘管,分体式空调",
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        controlType: data.controlType,
        key: data.key,
        value: data.value,
      });
      if (res && res.data.code == 200) {
        this.$message.success("操作成功");
        setTimeout(() => {
          this.getMachineRoomList();
        }, 1000);
      }
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.MachineRoomCom {
  @include setCenterWH;
  @include setFlexStart;
  align-items: flex-start;
  align-content: flex-start;
  flex-wrap: wrap;
  overflow: auto;
  li {
    width: calc(50% - 15px);
    background: #fff;
    border-radius: 6px;
    margin: 0 15px 10px 0;
  }
}
</style>
